import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CropImage from './CropImage';

class ImagesCropping extends Component {
  state = {
    images: [],
    imageInFocus: null,
  };

  // TODO Should be tested if/when this will be used
  constructor(props) {
    super(props);

    this.setInFocus = this.setInFocus.bind(this);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    let { images } = this.props;
    if (images && images !== nextProps.images) {
      ({ images } = nextProps);
      const id = 'id';
      const imageInFocus = {
        id: images[0][id].$oid,
        filename: images[0].filename,
        memberId: images[0].member_id,
      };
      this.setState({ images, imageInFocus });
    }
  }

  setInFocus(id, filename, memberId) {
    this.setState({ imageInFocus: { id, filename, memberId } });
  }

  // TODO Should be tested if/when this will be used
  componenDidMount() {
    const { images } = this.props;
    let imageInFocus = null;

    if (images) {
      const id = 'id';
      imageInFocus = {
        id: images[0][id].$oid,
        filename: images[0].filename,
        memberId: images[0].member_id,
      };
    }

    this.setState({
      images,
      imageInFocus,
    });
  }

  render() {
    const {
      saveCentered,
      toCropUrlBase,
      saving,
      imageUrlBase,
    } = this.props;
    const { images, imageInFocus } = this.state;
    const content = [];
    const id = 'id';

    const toCrop = (
      <CropImage
        filename={imageInFocus.filename}
        imageId={imageInFocus.id}
        memberId={imageInFocus.memberId}
        key="imageInFocus"
        saveCentered={saveCentered}
        toCropUrlBase={toCropUrlBase}
        saving={saving}
      />
    );

    if (images.length > 0) {
      images.forEach((image, index) => {
        if (image.filename) {
          const keyBase = 'crop_image_';
          const key = keyBase + index;
          const readyContent = (
            <button
              type="button"
              onClick={() => { this.setInFocus(image[id].$oid, image.filename, image.member_id); }}
              key={key}
              className="admin-cropThumbnail-container"
            >
              <img
                src={imageUrlBase + image.filename}
                alt=""
                className="admin-cropThumbnail-image"
              />
            </button>
          );
          content.push(readyContent);
        }
      });
    }

    return (
      <div>
        {toCrop}
        <hr className="admin-cropSeperator-hr" />
        {content}
      </div>
    );
  }
}

ImagesCropping.propTypes = {
  images: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
  saveCentered: PropTypes.func.isRequired,
  imageUrlBase: PropTypes.string.isRequired,
  toCropUrlBase: PropTypes.string.isRequired,
  saving: PropTypes.bool.isRequired,
};

ImagesCropping.defaultProps = {
  images: [],
};

export default ImagesCropping;
